import { useEffect } from 'react'
import { useTranslation } from "react-i18next";

export const AbstructLang = () => {
    const [translate, i18n] = useTranslation();
    useEffect(() => {
        i18n.changeLanguage(localStorage.getItem('pentalensLang'));
    }, []);

    return {
        translate,
        i18n
    }
}